<template>
  <div class="zx">
    <div class="editable-content-wrapper">
      <div class="model-wrapper">
        <ul>
          <li
            @mouseenter="handleOver($event)"
            @mouseleave="handleLeave($event)"
            v-for="(item, index) in list"
            :key="item.id"
          >
            {{ item.title }}
            <div class="edit-list">
              <van-button type="primary" size="mini">编辑</van-button>
              <van-button
                @click="handleUp(item, index)"
                type="info"
                size="mini"
                v-show="index !== 0"
                >上移</van-button
              >
              <van-button
                type="warning"
                size="mini"
                @click="handleDown(item, index)"
                v-show="index !== list.length - 1"
                >下移</van-button
              >
              <van-button
                type="danger"
                @click="handleDelete(item, index)"
                size="mini"
                >删除</van-button
              >
            </div>
          </li>
        </ul>

        <!-- <div class="model-title">
          模块列表
          <van-button size="small" type="primary">新增</van-button>
        </div>
        <ul class="list-edits">
          <li class="item-dom" @click="handleOver($event)">1</li>
          <li class="item-dom" @click="handleOver($event)">2</li>
          <li class="item-dom" @click="handleOver($event)">3</li>
        </ul>
        <div class="editable_model_handle_list">
          <a href="javascript:void(0)" class="handle_edit">编辑</a>
          <a href="javascript:void(0)" class="handle_move_up">上移</a>
          <a href="javascript:void(0)" class="handle_move_down">下移</a>
          <a href="javascript:void(0)" class="handle_drop">删除</a>
        </div> -->
      </div>
    </div>
    <div v-html="htmlEL"></div>
  </div>
</template>
<script>
import { requestApi } from '@/util/network.js'
export default {
  name: 'MemberZx',
  data() {
    return {
      list: [
        { id: 1, title: '1' },
        { id: 2, title: '2' },
        { id: 3, title: '3' },
        { id: 4, title: '4' }
      ],
      isShowList: false,
      htmlEL: `<div class="editable-page-model editable-page-model-h5-6" data-load="0" data-type="editable_model" data-id="80807" style="background-color:unset;"> 
   <div class="editable-page-content" style="padding-top:0;padding-bottom:0;"> 
    <div class="product-list"> 
     <div class="product-list-header" data-type="text" data-id="0"> 
      <div class="header-title">标题</div> 
     </div> 
     <div class="product-list-body" data-type="goods" data-id="0"> 
               <div class="product-info border"> 
       <img class="product-icon" src="https://wd-siyb.oss-cn-shanghai.aliyuncs.com/home/store/goods/86/20210522/alioss_86_2021052211221871536.jpg?x-oss-process=image/resize,m_pad,w_240,h_240" /> 
       <span class="product-title">黄金手镯</span> 
       <div class="product-bottom"> 
        <span class="product-price">￥12000.00</span> 
        <span class="product-buy">2人已购买</span> 
       </div> 
      </div> 
               <div class="product-info "> 
       <img class="product-icon" src="https://wd-siyb.oss-cn-shanghai.aliyuncs.com/home/store/goods/86/20210522/alioss_86_2021052211522583097.jpeg?x-oss-process=image/resize,m_pad,w_240,h_240" /> 
       <span class="product-title">黄金项链</span> 
       <div class="product-bottom"> 
        <span class="product-price">￥33333.00</span> 
        <span class="product-buy">0人已购买</span> 
       </div> 
      </div> 
              </div> 
    </div> 
   </div> 
  </div>


`
    }
  },
  created() {
    // this.ajax.get(
    //   '/home/seller_editable_page/model_add?editable_page_id=17669&type=h5'.then(
    //     (res) => {
    //       console.log(res)
    //     }
    //   )
    // )
    // requestApi('/model_add', 'GET', {
    //   editable_page_id: 17669,
    //   type: 'h5'
    // }).then((res) => {
    //   console.log(res)
    // })
  },
  methods: {
    handleOver(even) {
      even.target.style.border = '1px dashed #0579c6'
      even.target.children[0].style.display = 'block'
    },
    handleLeave(even) {
      even.target.style.border = '1px solid #bcbcbc'
      even.target.children[0].style.display = 'none'
    },
    handleUp(item, index) {
      if (index !== 0) {
        this.list[index] = this.list.splice(index - 1, 1, this.list[index])[0]
      } else {
        this.list.push(this.list.shift())
      }
    },
    handleDown(item, index) {
      if (index !== this.list.length - 1) {
        this.list[index] = this.list.splice(index + 1, 1, this.list[index])[0]
      } else {
        this.list.unshift(this.list.splice(index + 1)[0])
      }
    },
    handleDelete(item, index) {
      this.list.splice(index, 1)
    }
  }
}
</script>
<style lang="scss" scoped>
.model-wrapper {
  margin: 0 12px;
  .model-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 12px 0;
  }
}
.editable-content-wrapper {
}
.list-edits {
  position: relative;
}
.item-dom {
  // position: relative;
  margin: 0 0 20px;
  height: 100px;
  border: 1px solid #bcbcbc;
  border-radius: 8px;
}

// 操作
.editable_model_handle_list {
  position: absolute;
  top: 110px;
  right: 20px;
  a {
    display: inline-block;
    text-align: center;
    margin-left: 5px;
    position: relative;
    top: -30px;
    width: 50px;
    height: 30px;
    line-height: 30px;
    color: #fff;
    font-size: 12px;
    &:link,
    &:visited,
    &:active {
      text-decoration: none;
    }
  }
  .handle_edit {
    background: #288ee4;
  }
  .handle_move_up {
    background-color: #00af26;
  }
  .handle_move_down {
    background-color: #ffb64a;
  }
  .handle_drop {
    background-color: #ea6060;
  }
}
</style>
<style lang="scss" scoped>
ul {
  li {
    position: relative;
    height: 80px;
    margin: 20px 0;
    border: 1px solid #bcbcbc;
  }
}
.edit-list {
  position: absolute;
  display: none;
  top: 0;
  right: 0;
}
</style>
